<template>
<div>
  <div id="banderoll" class="start start0" >


<div id="textkontainer">

    <router-link  class="linkstyle2" to="/">
        <h1 id="titelrad" class="fontface storH1" @click="scrollToTop()">Tysk Grammatik</h1>
    </router-link>

<div id="valrad" class="valrad">


    <router-link class="linkstyle" to="/ovningar" >
                  <div class="valknapp">
                    Övningar
                  </div>
  </router-link>


  <router-link class="linkstyle" to="/grammatikboken">
                <div class="valknapp">
                  Grammatikboken
                </div>
  </router-link>


  <div class="pseudo-link" to="/testovning">

                <!--div class="valknapp linkstyle" @onmouseover="bytSynlighet()"" @mouseover="visaRullgardin()" @mouseout="doljRullgardin()"-->
                <div id="valknapp" class="valknapp linkstyle">
                  {{ steg }}
                </div>


                <Rullgardin :someValue="value" @update="onStep1Update" v-if="synsRullgardin  === true"/>





</div>






</div>

</div>



  </div>

<div id="pseudomarginal" class="osynlig">
</div>

</div>
</template>

<script>

import Rullgardin from './startvy/rullgardin.vue'

export default {
  name: 'HeaderField',
  props: {
    msg: String,
    //synsRullgardin: Boolean,


    },
    data() {
        return {
            steg: String,
            synsRullgardin: false,
            value: true


        }
    },
    components: {
        Rullgardin
    },
    methods:  {
      scrollToTop() {
          window.scrollTo(0,0);
        },
        onStep1Update (newData) {
            this.value = newData;
            this.synsRullgardin = false;
  },
        bytSynlighet(event) {
            event.stopPropagation();
            this.synsRullgardin = !(this.synsRullgardin);

        },
        andraHeader() {
            var winY=window.scrollY;
            var winWidth= window.innerWidth;
            var banderoll = window.document.getElementById('banderoll');
            var titelrad = window.document.getElementById('titelrad');
            var valrad = window.document.getElementById('valrad');
            var rullgardin = window.document.getElementById('rullgardin');
            var pseudomarginal = window.document.getElementById('pseudomarginal');
            var textkontainer = window.document.getElementById('textkontainer');
            //om vi är på sida grammatikboken skall banderollen alltid vara tunn och överst oavsett skroll
            if(document.title.includes("boken")) {

                banderoll.classList.add("start3");

                banderoll.classList.remove("start");
                banderoll.classList.remove("start2");

                valrad.classList.add("ilinje");
                titelrad.classList.remove("storH1");
                titelrad.classList.add("litenH1");
                pseudomarginal.classList.remove("osynlig");
                try {
                    rullgardin.classList.remove("rullgard");
                    rullgardin.classList.add("rullgard2");
                } catch(err) {
                    // så att rullgardin inte behöver vara synlig
                }


            } else if(winY>50 || document.title.includes("boken") || winWidth <=480  ) {
                banderoll.classList.add("start2");

                banderoll.classList.remove("start");
                banderoll.classList.remove("start3"); // osäker om ska vara med

                textkontainer.classList.add("mjuktfram");
                valrad.classList.add("ilinje");
                titelrad.classList.remove("storH1");
                titelrad.classList.add("litenH1");
                pseudomarginal.classList.remove("osynlig");
                try {
                    rullgardin.classList.remove("rullgard");
                    rullgardin.classList.add("rullgard2");
                } catch(err) {
                    // så att rullgardin inte behöver vara synlig
                }


            } else {
                banderoll.classList.add("start");
                banderoll.classList.remove("start3"); // osäker om ska vara med
                banderoll.classList.remove("start2");
                textkontainer.classList.remove("mjuktfram");
                valrad.classList.remove("ilinje");
                titelrad.classList.remove("litenH1");
                titelrad.classList.add("storH1");
                pseudomarginal.classList.add("osynlig");
                try {
                    rullgardin.classList.remove("rullgard2");
                    rullgardin.classList.add("rullgard");
                } catch(err) {
                    // så att rullgardin inte behöver vara synlig
                }

            }
        }

    },
    mounted() {

        var that = this;
        document.getElementById('valknapp').addEventListener('click', function(event) {
            event.stopPropagation();
            that.synsRullgardin = !(that.synsRullgardin);


        });
        if (window.document.done["Steg"] == "") {
            window.document.done["Steg"] == 0
            this.steg = "Alla steg"
            } else {
                this.steg = "Steg " + window.document.done["Steg"]
            }

        //window.document.addEventListener("scroll", this.andraHeader());


        window.onscroll = function() {that.andraHeader()};
        },
    updated() {
        if (window.document.done["Steg"] == "") {
            window.document.done["Steg"] == 0
            this.steg = "Alla steg"
            } else {
                this.steg = "Steg " + window.document.done["Steg"]
            }
        this.andraHeader();

        },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/*h1 {
    margin:0;
    padding-top:10px;
    font-size: 100px;
}*/

#pseudomarginal {
    height: 115px;

}

.storH1 {
    margin:0;
    padding-top:10px;
    font-size: 100px;
}

.litenH1 {
    margin:0;
    padding-top:10px;
    font-size: 50px;
    /*color: red;*/
    display: inline;
    padding-left: 50px;
}


.valknapp {
    display: inline;
}


.ilinje {
    display: inline;
}

.valrad {
    margin-bottom: 1.5em;
}

.valknapp {
    padding-left: 2em;
    padding-right: 2em;
}
h3 {
  margin: 40px 0 0;
}







/*@media (max-width: 300px) {
    h1 {
        font-size:2em;
    }
    .valknapp {
        padding: 0;
    }
}*/



.linkstyle {
    font-size: 1.2em;
    color: #2c3e50;
    text-decoration: none;
}

.linkstyle:hover {
    color:brown;
    transition: .5s;
}


.linkstyle2 {
    /*font-size: 1.2em;*/
    color: #2c3e50;
    text-decoration: none;
}

.start0 {
    background-color: white;
}

.start {
    width: calc(100vw - 463px);

    display: inline-block;
    background: rgba(255, 255, 255, 0.7);
    box-shadow: 0 19px 38px rgba(0,0,0,0.30), 0 15px 12px rgba(0,0,0,0.22);
    color: black;
    margin-bottom: 20px;
    margin-top: 20px;

    ö-transition: width 0.15s;/*för långsam ändring när längst upp*/
    transition: width 0.45s;
}


.start2 {
    background-color: white;
    /*background: rgba(255, 255, 255, 0.7);*/
    background-color: #e8e8ee;
    position: fixed;
    /*box-shadow: 0 19px 38px rgba(0,0,0,0.30), 0 15px 12px rgba(0,0,0,0.22);*/
    color: black;
    margin-bottom: 20px;
    z-index: 100;
    width: 100%;
    padding-bottom: 10px;

    border-bottom: 1px solid;
    border-color: grey;
    /*text-align: left;*/
    /*transition: width 0.15s tar bort pga annars fult vid på/av grammatikspalt*/
    ö-transition: width 0.15s;
    transition: width 0.45s;
}

.start3 { /*för grammatikbok. ständigt fast banderoll/*
    background-color: white;
    /*background: rgba(255, 255, 255, 0.7);*/
    background-color: #e8e8ee;
    position: fixed;
    /*box-shadow: 0 19px 38px rgba(0,0,0,0.30), 0 15px 12px rgba(0,0,0,0.22);*/
    color: black;
    margin-bottom: 20px;
    z-index: 100;
    width: 100%;
    padding-bottom: 10px;

    border-bottom: 1px solid;
    border-color: grey;
    /*text-align: left;*/

}


@media (max-width: 1024px) {
    .start {
        width: 100%;
    }
}


@media (max-width: 700px) {
    .fontface {
    font-size:80px;
    }
    .linkstyle {
        font-size: 1.2em;
        color: #2c3e50;
        text-decoration: none;
    }
}

@media (max-width: 700px) {
    .fontface {
    font-size:60px;
    }
}


@media (max-width: 550px) {
    h1 {
        font-size: 3em;
    }
    /*.valknapp {
        display: block;
    }*/
    .valrad {
        margin-bottom: .5em;
    }

}


@media (max-width: 480px) {

    .valknapp {
        padding: 10px;
    }

    .start2 {

        position: fixed;
        /*box-shadow: 0 19px 38px rgba(0,0,0,0.30), 0 15px 12px rgba(0,0,0,0.22);*/
        color: black;
        margin-bottom: 20px;
        z-index: 100;
        width: 100%;
        padding-bottom: 10px;

        border-bottom: 1px solid;
        border-color: grey;
    }
    .litenH1 {
        margin:0;

        font-size: 30px;
        display: block;
        margin-top:-10px;
        margin-bottom: 3px;
        /*color: red;*/

    }





}






.osynlig {
    display: none;
}


.pseudo-link {
    color: #2c3e50;
    text-decoration: none;
    display: inline;
}

.pseudo-link:hover {
    color:brown;
    transition: .5s;
    cursor: pointer;
}

.linkstyle2:hover {
    background-color: white;
}

/*experiment 250103 för att snygga till tyskgrammatik banderollern*/

/* Safari 4.0 - 8.0 */

/*
@-webkit-keyframes mjukframkomst {
  from {
      opacity: 0;
  }
  to {
      opacity: 1;
  }
}

/* Standard syntax */

/*
@keyframes mjukframkomst {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}
*/

@-webkit-keyframes mjukframkomst {
  0% { opacity: 0; }
  80% { opacity: 0; }
  100% { opacity: 1; }
}

@keyframes mjukframkomst {
  0% { opacity: 0; }
  80% { opacity: 0; }
  100% { opacity: 1; }

}


.mjuktfram {
    -webkit-animation: mjukframkomst 0.5s; /* Safari 4.0 - 8.0 * tiden :0.8*/
    animation: mjukframkomst 0.5s;
}


</style>
